export default __webpack_public_path__ + "static/media/check.3ec0b1a2.svg";